<template>
  <div>
    <el-menu :default-active="active" class="el-menu-vertical-demo" background-color="#112f50" text-color="#fff"
      active-text-color="#ffd04b" :collapse="isCollapse">
      <el-menu-item>
        <span slot="title">格瑞电竞后台管理系统</span>
      </el-menu-item>
      <el-menu-item index="home" @click="toPage('home')" >
        <i class="el-icon-s-home"></i>
        <span slot="title">价目列表</span>
      </el-menu-item>
      <!-- 新增：首页配置菜单项 -->
      <el-menu-item index="homeConfig" @click="toPage('homeConfig')" >
        <i class="el-icon-setting"></i>
        <span slot="title">首页配置</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import MenuList from './MenuList.vue'
import { mapState } from 'vuex'
export default {
  props: ['isCollapse'],
  components: {
    MenuList
  },
  computed: {
    ...mapState('menu', ['dyMenuList'])
  },
  data() {
    return {
      // isCollapse:false
      active: ''
    }
  },
  methods:{
    toPage(name){
      this.$router.push({
        name
      })
    }
  },
  // 监听路由变化，高亮当前菜单
  watch: {
    '$route.name': {
      handler(newName) {
        // 根据路由名称设置高亮的菜单项
        if (newName === 'home') {
          this.active = 'home'
        } else if (newName === 'homeConfig') {
          this.active = 'homeConfig'
        } else if (newName === 'list' || newName === 'addProduct') {
          this.active = 'product' // 如果有价目管理菜单，可以在这里处理
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.el-menu {
  border-right: 0;

  /deep/ .is-active {
    background: #1e78bf !important;
    color: #fff !important;
  }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>